import { Component } from '@theme/component';

/**
 * A custom element that manages product information tabs (Description, Directions, Ingredients).
 * Handles declarative tab switching.
 *
 * @extends {Component}
 */
class ProductInfoTabsComponent extends Component {
  requiredRefs = ['tabButtons', 'tabContents'];

  /**
   * Switch the active tab content based on query parameters.
   * @param {Object} data - Parsed query parameters (e.g. { tab: 'description' })
   * @param {Event} event - The click event
   */
  switchTab = (data, event) => {
    const targetTab = data.tab;
    if (!targetTab) return;

    // Toggle active state on buttons
    if (Array.isArray(this.refs.tabButtons)) {
      this.refs.tabButtons.forEach(btn => {
        const btnClickAttr = btn.getAttribute('on:click') || '';
        const isTarget = btnClickAttr.includes(`tab=${targetTab}`);
        btn.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        btn.classList.toggle('active', isTarget);
      });
    } else if (this.refs.tabButtons) {
      const btnClickAttr = this.refs.tabButtons.getAttribute('on:click') || '';
      const isTarget = btnClickAttr.includes(`tab=${targetTab}`);
      this.refs.tabButtons.setAttribute('aria-selected', isTarget ? 'true' : 'false');
      this.refs.tabButtons.classList.toggle('active', isTarget);
    }

    // Toggle visibility on content sections
    if (Array.isArray(this.refs.tabContents)) {
      this.refs.tabContents.forEach(content => {
        const isTarget = content.getAttribute('data-tab') === targetTab;
        content.style.display = isTarget ? 'block' : 'none';
        content.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      });
    } else if (this.refs.tabContents) {
      const isTarget = this.refs.tabContents.getAttribute('data-tab') === targetTab;
      this.refs.tabContents.style.display = isTarget ? 'block' : 'none';
      this.refs.tabContents.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
    }
  };
}

if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', ProductInfoTabsComponent);
}
